import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Gift({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M12 21V7.99999M15.696 6.60999C14.616 7.72999 12.916 7.99799 12.096 7.99799M12.09 7.99999C12.09 7.99999 11.59 4.87999 12.81 3.61999M15.69 6.60999C16.48 5.77999 16.48 4.43999 15.69 3.60999C14.89 2.77999 13.6 2.77999 12.815 3.60999M11.89 7.99799C11.07 7.99799 9.37 7.72999 8.3 6.60999C7.5 5.77999 7.5 4.43999 8.3 3.60999C9.09 2.77999 10.38 2.77999 11.175 3.60999M11.901 7.99999C11.901 7.99999 12.391 4.87999 11.171 3.61999M19 12V20C19 20.55 18.55 21 18 21H6C5.44 21 5 20.55 5 20V12M20 7.99999H4C3.448 7.99999 3 8.43999 3 8.99999V11C3 11.55 3.44 12 4 12H20C20.55 12 21 11.55 21 11V8.99999C21 8.43999 20.55 7.99999 20 7.99999Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Gift;